/* eslint-disable */
import { each, map, contains } from 'lodash';
import base64 from './base64';
import { getTestResult } from './templates';
import { abbreviateNumber } from '~/modules/common/utils/stringUtils';
import { API_URL, COUNTERS_LAMBDA_URL, TWITTER_USERNAME, LANG } from '@/constants/config';
import i18n from '~/i18n';

const base = API_URL + '/v3.5';

let $main;
let url;
let title;
let viewScope;
let storage;
let article;

/**
 * @info It shuffles which is given array
 * @param array
 * @return {Array}
 */

/**
 * TinyEncrypt
 *
 * @param {string} val - value
 * @param {string} key - key
 * @param {object} entry = entryVariantQuestion'daki gibi `val` parametresi yerine key verilirse ikinci parametre olan key icin entry.id kullaniliyor o yuzden entry gondermek zorundayiz.
 * Sebebini bilmiyorum bu kodu yillar once yazmislar, sanki meb testleri? onedio testleri icin bu kadar encyrption'a gerek var miydi gercekten?
 */
export function tinyEncrypt(val, key, entry = { _id: '' }) {
  var key = key || entry._id.toString();
  val = val || '';
  const ret = [];
  for (let i = 0; i < val.length; i++) {
    ret.push(val.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return ret
    .map(function (c) {
      return c.toString(36);
    })
    .join('.');
}

/**
 * TinyDecrypt
 * @param {string} val - value
 * @param {string} key - key
 */
export function td(val, key) {
  val = map(String(val).split('.'), function (x) {
    return parseInt(x, 36);
  });

  let res = '';
  for (let i = 0; i < val.length; i++) {
    const code = val[i] ^ key.charCodeAt(i % key.length);
    res += String.fromCharCode(code);
  }

  return res;
}

export async function init(data) {
  storage = await import('./storage.js');
  article = data.article;
  $main = data.$main;
  url = data.url;
  title = data.title;
  viewScope = data.viewScope || window.require('info').page.viewScope;
  var categoryName = viewScope === 'mobile' ? 'Mobile_User' : 'Desktop_User';

  // article paylaşma kısmında yeniden dene butonu göstermek için
  if (article.tags?.includes('~reset')) {
    $(window).on('testFinish', function () {
      $('section.entry.question').off('click tap');

      setTimeout(function () {
        $('.share-test-result').append(
          '<br><a href="#" onclick="window.gtag(`event`, `User_Engagement`, {event_category:`' +
            categoryName +
            '`, event_label: `test_reload`});location.reload(true);" class="share-res try-quiz-again" style="background-color: #1a1;display: block;margin: 13px auto 0 auto;font-size: 15px;"><i class="fa fa-refresh"></i>Yeniden Dene</a>'
        );
      }, 200);
    });
  }
}

// wrapper for all scroll operations, usefull for not doing anyscroll in webviews
export function scrollWrapper(selector, scrollTop, animateLength) {
  if ('pingScrollToWebview' in window && typeof window.pingScrollToWebview === 'function') {
    window.pingScrollToWebview(scrollTop);
  } else {
    window.scrollTo({
      top: scrollTop - 50,
      left: 0,
      behavior: 'smooth',
    });
  }
}

export function getMedium($this) {
  if ($this.hasClass('fb')) return 'Facebook';
  else if ($this.hasClass('tw')) return 'Twitter';
  else if ($this.hasClass('wsp')) return 'Whatsapp';
}

export function sendResultsToFloodlight() {
  if (
    ![
      '771662',
      '747106',
      '738333',
      '764357',
      '774821',
      '777617',
      '770710',
      '767194',
      '742145',
      '745366',
      '743356',
      '742642',
      '729032',
      '741697',
      '782721',
      '785541',
      '793655',
      '729032',
      '806102',
      '811422',
      '812670',
      '818941',
      '821857',
      '820350',
      '823828',
      '827284',
    ].includes(article.legacyId)
  )
    return;

  // console.log('floodlight');
  let getQuery = '';
  let url = document.location.href;
  url = url.replace('https://', '');
  getQuery += 'u1=' + url + ';';

  title = title.replace("'", '%27');
  title = title.replace('’', '%27');

  // if (['771662', '747106', '738333', '764357', '774821'].includes(article.legacyId)) {
  //   for (let i = 1; i < fldChoices.length; i++) {
  //     if (fldChoices[i] !== undefined) {
  //       getQuery += 'u' + (i + 4) + '=' + encodeURIComponent(fldChoices[i]) + ';';
  //     }
  //   }
  //
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     `<script type="text/javascript">
  //         let axel = Math.random() + '';
  //         let a = axel * 10000000000000;
  //         document.write('<iframe src="https://5433616.fls.doubleclick.net/activityi;src=5433616;type=onedi0;cat=garni0;${getQuery}dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
  //       </script>`
  //   );
  // }
  // else if (['777617', '820350'].includes(article.legacyId)) {
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "let axel = Math.random() + '';" +
  //       'let a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5605611.fls.doubleclick.net/activityi;src=5605611;type=onedi0;cat=maybe0;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (['793655'].includes(article.legacyId)) {
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "let axel = Math.random() + '';" +
  //       'let a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5605611.fls.doubleclick.net/activityi;src=5605611;type=onedi0;cat=maybe00;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (['770710', '782721', '785541', '806102'].includes(article.legacyId)) {
  //   for (var i = 1; i < fldChoices.length; i++) {
  //     if (fldChoices[i] !== undefined) {
  //       getQuery += 'u' + (i + 4) + '=' + encodeURIComponent(fldChoices[i]) + ';';
  //     }
  //   }
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "var axel = Math.random() + '';" +
  //       'var a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5607231.fls.doubleclick.net/activityi;src=5607231;type=onedi0;cat=elsev0;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (
  //   ['767194', '742145', '745366', '743356', '742642', '729032', '741697', '729032', '823828', '827284'].includes(article.legacyId)
  // ) {
  //   for (var i = 1; i < fldChoices.length; i++) {
  //     if (fldChoices[i] !== undefined) {
  //       getQuery += 'u' + (i + 4) + '=' + encodeURIComponent(fldChoices[i]) + ';';
  //     }
  //   }
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "var axel = Math.random() + '';" +
  //       'var a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5605617.fls.doubleclick.net/activityi;src=5605617;type=onedi0;cat=lpcol001;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (['818941'].includes(article.legacyId)) {
  //   for (var i = 1; i < fldChoices.length; i++) {
  //     if (fldChoices[i] !== undefined) {
  //       getQuery += 'u' + (i + 4) + '=' + encodeURIComponent(fldChoices[i]) + ';';
  //     }
  //   }
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';u18=' + encodeURIComponent(fldResults) + ';';
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "var axel = Math.random() + '';" +
  //       'var a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5605617.fls.doubleclick.net/activityi;src=5605617;type=onedi0;cat=lpcol005;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (['811422'].includes(article.legacyId)) {
  //   getQuery = '';
  //   for (var i = 1; i < fldChoices.length; i++) {
  //     if (fldChoices[i] !== undefined) {
  //       if ([3, 4, 6].includes(i)) {
  //         getQuery += 'u' + i + '=' + encodeURIComponent(fldChoices[i]) + ';';
  //       }
  //     }
  //   }
  //   fldResults = fldResults.replace("'", '%27');
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "var axel = Math.random() + '';" +
  //       'var a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://8428196.fls.doubleclick.net/activityi;src=8428196;type=invmedia;cat=efk8rnun;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
  // else if (['812670', '821857'].includes(article.legacyId)) {
  //   fldResults = fldResults.replace("'", '%27');
  //   getQuery += 'u17=' + encodeURIComponent(title) + ';';
  //
  //   if (fldResults === 'Pek pürüzsüz değil gibi!') {
  //     getQuery += 'u18=' + encodeURIComponent('Puruzsuzdegil') + ';';
  //   } else if (fldResults === 'Eh, fena sayılmaz!') {
  //     getQuery += 'u18=' + encodeURIComponent('Fenasayilmaz') + ';';
  //   } else if (fldResults === 'Bebeksi pürüzsüzlüğe 1 kala!') {
  //     getQuery += 'u18=' + encodeURIComponent('Bebeksi') + ';';
  //   }
  //
  //   console.log(getQuery);
  //
  //   postscribe(
  //     $('body'),
  //     '<script type="text/javascript">' +
  //       "var axel = Math.random() + '';" +
  //       'var a = axel * 10000000000000;' +
  //       'document.write(\'<iframe src="https://5607006.fls.doubleclick.net/activityi;src=5607006;type=onedi0;cat=lpder0;' +
  //       getQuery +
  //       'dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=\' + a + \'?" width="1" height="1" frameborder="0" style="display:none"></iframe>\'); </script>'
  //   );
  // }
}
export function provideResults(options, $entry, shareQuizResult) {
  options = options || {};
  const eid = $entry.attr('data-id');

  const keys = $entry
    .find('div.answers .answer')
    .map(function (answer) {
      return 'entry:' + eid + ':poll:' + td($(this).data('key'), eid);
    })
    .get();
  $.ajax({
    url: `${COUNTERS_LAMBDA_URL}/batch`,
    // beforeSend: function(request) {
    //   request.setRequestHeader("referer", 'https://onedio.com/');
    //   request.setRequestHeader("origin", 'https://onedio.com');
    // },
    method: 'POST',
    data: keys
      .map(function (key) {
        return 'keys=' + key;
      })
      .join('&'),
  })
    .then(function (data) {
      const hr = $entry.find('div.answers').data('historicresults') || {};
      each(Object.keys(data), function (key) {
        data[key] += hr[key.split(':').pop()] || 0;
      });
      const keys = Object.keys(data);
      const total = Object.values(data).reduce((m, a) => m + a || 0);

      data = keys.map(function (key) {
        return {
          key: key.split(':').pop(),
          count: data[key],
          percentage: (data[key] / total || 0).toFixed(2),
          total,
        };
      });

      let $max = $();
      let maxp = 0;

      each(data, function (provided) {
        $entry.find('div.answers .answer').each(function () {
          const $answer = $(this);

          if (td($answer.data('key'), eid) === provided.key) {
            const text = `% ${Math.floor(100 * provided.percentage)} (${abbreviateNumber(
              provided.count,
              provided.count > 10000 ? 0 : 1
            ).toUpperCase()} oy)`;
            const $answerWrapper = $answer.find('div.answer-inline-wrapper').length
              ? $answer.find('div.answer-inline-wrapper')
              : $('<div></div>').addClass('answer-inline-wrapper');
            const $countText = $('<span></span>').addClass('result-text').text(text);
            const $resultSize = $answer.outerHeight() - $answer.find('figure.answer__image').outerHeight();
            $answer.find('div.answer-inline-wrapper').css({ bottom: $resultSize });

            if (!$answer.find('span.result-text').length && !$answer.hasClass('answer-line')) $answerWrapper.prepend($countText);

            if ($answer.hasClass('answer-line')) {
              const $answerBarWrapper = $answer.find('div.answer-bar-wrapper');
              $answerBarWrapper.css({ display: 'flex' });
              $answerBarWrapper.find('div.percentage-text').text(text);
              $answerBarWrapper.find('div.percentage-bar').animate(
                {
                  width: Math.floor(100 * provided.percentage) + '%',
                },
                200
              );
            }

            if (provided.percentage > maxp) {
              maxp = provided.percentage;
              $max = $answer;
            } else if (provided.percentage === maxp) {
              $max = $max.add($answer);
            }

            let answerWidth = 0;

            if (provided.percentage != 0) {
              answerWidth = 150 * provided.percentage;
            }
          }
        });
      });

      $max.find('div.answer-inline-wrapper').addClass('max');
      $max.find('div.percentage-bar').addClass('max');
      $entry.find('.reveal-result').hide();
    })
    .catch((err) => {
      // FIXME : Dummy data here
      // console.error(err);
      // let data = { 'entry:5a2d3040e78cdaf70ff0f06d:poll:1': 9240, 'entry:5a2d3040e78cdaf70ff0f06d:poll:2': 11848 };
    });

  if (!options.hideshare) {
    shareQuizResult.value = true;
    revealResult(
      {
        sharearticle: true,
        afterentry: $entry,
        noscroll: true,
      },
      shareQuizResult
    );
  }
}

export function recordAnswerOnSRV(article, id, answer) {
  if (!['774154', '779298', '794320'].includes(article.legacyId)) return;

  const localStorageKey = 'article-question-user';

  let articleQuestionUser = JSON.parse(window.localStorage.getItem(localStorageKey)) || false;

  if (!articleQuestionUser) {
    articleQuestionUser = Date.now() + Math.floor(Math.random()) * 1000;

    window.localStorage.setItem(localStorageKey, JSON.stringify(articleQuestionUser));
  }

  $.ajax({
    url: 'https://srv-store.onedio.com/store/kv',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: JSON.stringify({
      ns: 'article-question-answers:' + article.legacyId,
      key: Date.now() + Math.floor(Math.random()) * 1000,
      article: article.legacyId,
      user: articleQuestionUser,
      question: id,
      answer,
    }),
    contentType: 'application/json; charset=utf-8',
  });

  // console.log('recordAnswerOnSRV', article.legacyId, id, answer);
}

export function recordAnswer(id, answer) {
  const qanswers = storage.get('question-answers') || {};
  qanswers[id] = answer;
  storage.set('question-answers', qanswers);
}

export function keepTestCompletedInfo(legacyId) {
  const localStorageKey = '_oi_completedtest';
  const completedTests = JSON.parse(window.localStorage.getItem(localStorageKey)) || [];

  if (!completedTests.includes(legacyId)) {
    if (completedTests.length >= 10) completedTests.shift();

    completedTests.push(legacyId);
    window.localStorage.setItem(localStorageKey, JSON.stringify(completedTests));
  }
}

export function revealResult(options, shareQuizResult) {
  const fldChoices = [];
  let fldResults = '';
  let $res = options.res;
  // new quiz type result calculation
  if (options.testType === 'answer-with-score' && typeof options.totalScore !== 'undefined' && options.totalScore !== null) {
    $res = $main.find('section.entry[data-question-result]').filter(function () {
      const result = $(this).data('question-result');
      const scores = result.replace('[', '').replace(']', '').split('#');
      const from = scores[0];
      const to = scores[1];

      if (options.totalScore >= from && options.totalScore <= to) {
        return true;
      }
      return false;
    });
  } else if (typeof options.score !== 'undefined' && typeof options.total !== 'undefined' && (!$res || !$res.length)) {
    $res = $main.find('section.entry[data-question-result]').filter(function () {
      const result = /^([\(\[])(\d+)\s*\-\s*(\d+)([\)\]])$/.exec($(this).data('question-result') || '');

      if (!result) return false;

      let from = parseInt(result[2], 10);
      let to = parseInt(result[3], 10);

      if (result[1] === '[') from--;
      if (result[4] === ']') to++;

      if (options.score > from && options.score < to) return true;

      return false;
    });

    if ($res.length) {
      $res.map(function () {
        const $this = $(this);
        $this.html($this.html().replace('$score', options.score).replace('$total', options.total));
      });
    }
    $('.article section video').each(function () {
      if ($(this) && $(this).get(0)) $(this).get(0).play();
    });
  }

  const $questions = $main.find('section.question.entry');
  if ($questions.length == $questions.filter('.answered').length) {
    keepTestCompletedInfo(article.legacyId); // keep test completed info for firing only 1st answers of quiz questions to Adform.

    $main.find('section.entry[data-question-result]').each(function () {
      const $this = $(this);
      if ($this.data('question-result') === '*') $this.slideDown(300);
    });
  }

  // var urlDesktop = require("info").article.route;
  // Bunun ne oldugnu bilmiyorum. Usttekini comment-out ettim.
  // F.ex: haber/berkan-sezer-8233369

  const urlDesktop = location.toString();

  const conf = {
    url: urlDesktop,
    urlDesktop,
    // appId: window.oio ? window.oio.apps.facebook : '',
    // buraya facebook id gerekiyor mu?
    appId: window.oio ? 'fbidxxx' : '',
    viewScope,
  };
  // Jump to vue side :)
  // if (shareQuizResult.value) shareQuizResult.value = conf;

  if (options.numeric && !$main.hasClass('non-numeric')) {
    conf.text = i18n.messages[LANG]['news-page']['test-count-result'].replace('$score', options.score).replace('$total', options.total);
    conf.title = i18n.messages[LANG]['news-page']['test-final-result'].replace('$score', options.score).replace('$total', options.total);
  } else if ($res && $res.length) {
    const imageUrls = [];
    if ($res.data('result-product-id')) {
      const productNameAndIds = $res.data('result-product-id').split(',');

      for (let j = 0; j < productNameAndIds.length; j++) {
        imageUrls.push(productNameAndIds[j].split('|')[2]);
      }
    }

    conf.picurl =
      'http://srv-cdn.onedio.com/screenshot/' +
      base64.encode(
        JSON.stringify({
          u:
            'https://onedio.com/support/entry-share/' +
            $res.attr('data-id') +
            (imageUrls[0] ? '?imageurl=' + encodeURIComponent(imageUrls[0]) : ''),
          w: 800,
          h: 420,
        }),
        { urlsafe: true }
      ) +
      '.png';

    conf.resultId = $res.attr('data-id');
    conf.resultTitle = $res.children('h2').text();

    const restt =
      $res.data('question-result-title') || ($res.children('h2').length ? $res.children('h2').clone().find('*').remove().end().text() : '');

    conf.text = `${restt} ${title}`.trim();
    conf.twitterUsername = TWITTER_USERNAME;

    fldResults = restt;
    sendResultsToFloodlight();
    $res.show();
    scrollWrapper('html, body', $res.offset().top, 'smooth');
  } else if (options.sharearticle) {
    conf.text = title;
  } else {
    return;
  }
  if (window.bypassAfterTestShareActions !== undefined) {
    conf.bypassAfterTestShareActions = 'bypassAfterTestShareActions'; // on new appview, pass this to disable twitter share button onclick attribute
  }

  /**
   * her entrynin altinda acilan share butonlari:
   * @info ornek id: 799468
   */
  const shareResult = getTestResult(conf);
  const $box = $(shareResult).hide().slideDown(300);
  if (options.sharearticle) {
    $main.find('.share-article').slideDown(200, function () {
      $(this).remove();
    });

    $box.addClass('share-article');
  }

  //
  if ($res && $res.length) {
    $res.slideDown(100);
    $res.last().after($box);
  } else if (options.afterentry) {
    options.afterentry.after($box);
  } else {
    $main.find('section.question').last().after($box);
  }

  if (options.noscroll) return;

  setTimeout(function () {
    scrollWrapper(
      'html, body',
      ($res && $res.length ? $res.offset().top : $box.offset().top) - (conf.viewScope == 'desktop' ? 50 : -10),
      300
    );
  }, 100);

  let displaystoreview = true;

  // setTimeout(function () {
  const productIds = [];
  const imageUrls = [];
  let $resultsection;
  const a = $('section[data-question-result]');
  for (let i = 0; i < a.length; i++) {
    if ($(a[i]).css('display') == 'block') {
      // start segment

      if ($(a[i]).data('segmented') && $(a[i]).data('segments')) {
        const localStorageKey = 'question-sent-segments';
        const entrySentSegments = [];
        const entryId = $(a[i]).data('id');

        if (!entrySentSegments.includes(entryId)) {
          const $segments = $(a[i]).data('segments');

          if ($segments && $segments.length > 0) {
            $segments.forEach(function (segment) {
              const segmentArr = segment.split('|');
              const segmentUrl =
                (segment.indexOf('http') != 0 ? '//dmp.adform.net/dmp/profile/?pid=10548&sg=' : '') + segmentArr[segmentArr.length - 1];
              $('body').append("<img src='" + segmentUrl + "' style='position:absolute;display:none;'/>");
              // Pass data to IOS webkit
              if (window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.callBackHandler.postMessage({
                  sg: segmentArr[segmentArr.length - 1],
                });
              }
              $.get(`${base}/dmp/segments`, function ({ data }) {
                const segmentObject = data.find((segment) => {
                  if (segment.name === segmentArr[segmentArr.length - 1]) {
                    return true;
                  }
                });
                if (segmentObject) {
                  window.fbq('trackCustom', 'adform/audiencetag', {
                    SegmentID: segmentObject.id,
                    DataProviderID: 10548,
                    RefID: segmentObject.name,
                  });
                }
              });
            });
            entrySentSegments.push(entryId);
            window.localStorage.setItem(localStorageKey, JSON.stringify(entrySentSegments));
          }
        }
      }
      // end segment
      if (!$(a[i]).data('result-product-id')) {
        displaystoreview = false;
        return;
      }
      $resultsection = $(a[i]);

      const productNameAndIds = $(a[i]).data('result-product-id').split(',');
      for (let j = 0; j < productNameAndIds.length; j++) {
        const productId = productNameAndIds[j].split('|')[1];
        productIds.push(productId);
        imageUrls.push(productNameAndIds[j].split('|')[2]);
      }
      break;
    }
  }
  if (productIds.length == 0) {
    displaystoreview = false;
    return;
  }

  // if the iframe has already been embedded, don't embed it again
  if (!$resultsection.children('figure').children('iframe').length) {
    if (displaystoreview) {
      $resultsection.children('h2').remove();
      $resultsection.children('figure').children('figcaption').remove();
      let storeIframeSrc = 'https://store.onedio.com/display-single-mobile?productId=' + productIds[0];
      if (!conf.viewScope || conf.viewScope == 'desktop') {
        storeIframeSrc = 'https://store.onedio.com/display-single?productId=' + productIds[0];
      }
      let storehtml =
        '<iframe class="store" width="100%" height="' +
        (!conf.viewScope || conf.viewScope == 'desktop' ? '725' : '805') +
        '" scrolling="no" frameborder="no" src="' +
        storeIframeSrc +
        '"></iframe>';
      const trackinghtml =
        '<iframe height="0" width="0" scrolling="no" frameborder="no" src="https://store.onedio.com/display/test-result-tracking"></iframe>';
      storehtml += trackinghtml;
      $resultsection.children('figure').children('div').remove();
      $resultsection.children('figure').prepend(storehtml);
    }
  }
  // }, 50);
}

export function trackAnswer(ans) {
  const tracked = ['gender', 'age'];
  const attrs = {};
  const ansA = ans.split('?');

  if (ansA.length <= 1) return;

  ansA.shift();
  ansA.forEach(function (a) {
    const i = a.split('=');
    const k = i[0];
    const v = i[1];

    if (!tracked.includes(k) || !k || !v) return;

    attrs[k] = v;
  });

  if (!Object.keys(attrs).length) return;
  // FIXME: Burayi da Vue'ya tasimak lazim
  dispatcher.emit('track', { action: 'user:props:test', payload: attrs });
}

/*
 * @param answer answer-DOM
 * @param type string
 */
export function gaTrackAnswer(answer, type) {
  const legacyIds = [
    '700181',
    '713727',
    '589256',
    '713891',
    '613233',
    '713010',
    '717940',
    '728022',
    '771662',
    '747106',
    '738333',
    '764357',
    '774821',
    '770710',
    '767194',
    '742145',
    '745366',
    '743356',
    '742642',
    '729032',
    '741697',
    '782721',
    '785541',
    '729032',
    '806102',
    '811422',
    '812670',
    '818941',
    '821857',
    '820350',
    '823828',
    '827284',
  ];

  if (!legacyIds.includes(article.legacyId)) return;

  // FIXME: ROOT ga() baglaninca burasi duzelecek :)
  const eventCategory = 'Quiz - ' + (type || 'UNDEFINED_TYPE') + '_Answers';
  const eventAction = article.legacyId + '_' + article.title;
  const questionTitle = answer.closest('.entry').find('h2').length ? answer.closest('.entry').find('h2').text() : '';
  const answerTitle = answer.text();
  const eventLabel = questionTitle + ' _ ' + answerTitle;

  const questionNumber = questionTitle.split('.');
  const segments = answer.data('segments');

  if (segments !== undefined) {
    fldChoices[questionNumber[0]] = segments[0];
  }

  // ga.trackEvent(eventCategory, eventAction, eventLabel);
}
